import React from 'react'

const NewCalls = () => {
  return (
    <div>NewCalls</div>
  )
}

export default NewCalls
